module.exports = __webpack_public_path__ + "media/images/gallery/constellations/oc_layer_on-7c2e401a8abb34399d97318e3a45735d.jpg";